<span class="ant-modal-close-x">
  <ng-container *nzStringTemplateOutlet="modalConfig.modalCloseIcon; let closeIcon">
    <i nz-icon [nzType]="closeIcon" class="ant-modal-close-icon"></i>
  </ng-container>
</span>
